import React, { useState } from "react";
import UserSidebar from "../../components/UserDashboard/UserSidebar";
import logo from "../../assets/img/mse-logo.webp";
import AllTests from "./AllTests";
import MyTests from "./MyTests";
import Footer from "../../components/Footer/Footer";
import Interview from "./Interviews/InterviewList";
import InterviewDetails from "./Interviews/InterviewDetail";
import Dashboard from "./Dashboard";
import { useLocation,useNavigate } from "react-router-dom";
import ListPayment from '../UserDashboard/Payment/ListPayment';
import Account from '../UserDashboard/Account';
import MySubscription from '../UserDashboard/MySubscription';
import UcatCalculator from '../UserDashboard/UcatCalculator';

const UserDashboard = () => {
 
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const tab = urlParams.get("tab") ?? "";
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  
  const logout = () => {
    const confirm = window.confirm("Are you sure? you want to logout?");
    if (confirm) {
      localStorage.removeItem("user");
      navigate("/");
    }
  };

  return (
    <div className="dashboard-body">
      <div className="topbar-border">
        <div className=" px-3 py-2">
          <img src={logo} alt="MSE Logo" width={'180px'} />
            <div class="topbar-account float-end">
              <h4 class="mx-3 mt-3">{user?.username} <button className="mx-3 btn btn-base btn-sm" type="button" onClick={() => logout()}>
                Logout <i className="bi bi-box-arrow-right"></i></button></h4>
              <h6 class="mx-3">Email:<span class="fw-lighter mx-2">{user?.email} </span>
              </h6>
            </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 dashboard-left-side">
            <UserSidebar />
          </div>
          <div className="col-md-9">
            <div className="right-bar mt-5">
              {tab === "" && <Dashboard />}

              {tab === "allTest" && <AllTests />}

              {tab === "myTest" && <MyTests />}

              {tab === "interviews" && <Interview />}
              {tab === "interviews-details" && <InterviewDetails  />}
              {tab === "calculator" && <UcatCalculator />}

              {tab === "payments" && <ListPayment />}
              {tab === "account" && <Account />}
              {tab === "my-subscription" && <MySubscription />}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default UserDashboard;
